module.exports = __webpack_public_path__ + "media/svg-new/dictionary-1c7a2106.svg";